import React, { useState } from "react";
import { Button, Card, Checkbox, Flex, Modal, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

interface ReplaceModeCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

function ExampleBlock({
  checked,
  after,
}: {
  checked: boolean;
  after: string;
}) {
  return (
    <Card
      size="small"
      bordered
      style={{ background: "#fafafa", borderRadius: 8 }}
    >
      <Flex vertical gap={12}>
        <Flex align="center" gap={8}>
          <Checkbox checked={checked} disabled />
          <Text strong>{checked ? "Checked" : "Unchecked"}</Text>
        </Flex>
        <Flex vertical gap={4}>
          <Text>Product: Japan eSIM</Text>
          <Text type="secondary">Now: 5 variants</Text>
          <Text type="secondary">File: 3 variants</Text>
          <Text strong>{after}</Text>
        </Flex>
      </Flex>
    </Card>
  );
}

export default function ReplaceModeCheckbox({
  checked,
  onChange,
  disabled,
}: ReplaceModeCheckboxProps) {
  const [helpOpen, setHelpOpen] = useState(false);

  return (
    <>
      <Flex align="center" gap={4} wrap="wrap">
        <Checkbox
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
        >
          Check this to replace products with same titles
        </Checkbox>
        <Button
          type="text"
          size="small"
          icon={<InfoCircleOutlined style={{ color: "rgba(0,0,0,0.45)" }} />}
          onClick={() => setHelpOpen(true)}
          aria-label="How replace works"
        />
      </Flex>
      <Modal
        title="Replace products with the same title"
        open={helpOpen}
        onCancel={() => setHelpOpen(false)}
        footer={
          <Button onClick={() => setHelpOpen(false)}>Close</Button>
        }
        width={440}
        destroyOnClose
      >
        <Flex vertical gap={16} style={{ paddingTop: 4 }}>
          <ExampleBlock checked after="After upload: 3 variants" />
          <ExampleBlock
            checked={false}
            after="After upload: 5 variants (3 updated, 2 kept)"
          />
          <Text type="secondary">
            Products not in the file are never deleted.
          </Text>
        </Flex>
      </Modal>
    </>
  );
}
